import { LoggingLevel } from "@/utils/logger/constants";
import { appConfig } from "@/guards/auth/azure-b2c.config";

export const getLogLevel = () =>
  Number(
    appConfig?.FEATURES?.LOG_LEVEL
      ? appConfig?.FEATURES.LOG_LEVEL
      : LoggingLevel.All,
  );
